import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import usePageMeta from "../../utils/usePageMeta";

const Journal = () => {
  usePageMeta({
    title: "Journal | MD Wedding Props",
    description:
      "Read updates, ideas, and inspiration from MD Wedding Props.",
    keywords: "wedding inspiration, decor ideas, wedding props journal",
  });

  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");
  useEffect(() => {
    setPrevLocation(location.state.data);
  }, [location]);
  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Journals" prevLocation={prevLocation} />
      <div className="pb-10">
        <h1 className="max-w-[600px] text-base text-lightText mb-2">
          <span className="text-primeColor font-semibold text-lg">Md Wedding Props</span>{" "}
          Continue shopping with MD Wedding Props for all your event essentials.
        </h1>
        <Link to="/shop">
          <button className="w-52 h-10 bg-primeColor text-white hover:bg-black duration-300">
            Continue Shopping
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Journal;
